import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3 15H7.5C8.32843 15 9 15.6716 9 16.5V21C9 21.8284 8.32843 22.5 7.5 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V16.5C1.5 15.6716 2.17157 15 3 15ZM16.5 1.5H21C21.8284 1.5 22.5 2.17157 22.5 3V7.5C22.5 8.32843 21.8284 9 21 9H16.5C15.6716 9 15 8.32843 15 7.5V3C15 2.17157 15.6716 1.5 16.5 1.5ZM16.5 15C15.6716 15 15 15.6716 15 16.5V21C15 21.8284 15.6716 22.5 16.5 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V16.5C22.5 15.6716 21.8284 15 21 15H16.5ZM16.5 0C14.8431 0 13.5 1.34315 13.5 3V7.5C13.5 9.15685 14.8431 10.5 16.5 10.5H21C22.6569 10.5 24 9.15685 24 7.5V3C24 1.34315 22.6569 0 21 0H16.5ZM3 13.5C1.34315 13.5 0 14.8431 0 16.5V21C0 22.6569 1.34315 24 3 24H7.5C9.15685 24 10.5 22.6569 10.5 21V16.5C10.5 14.8431 9.15685 13.5 7.5 13.5H3ZM13.5 16.5C13.5 14.8431 14.8431 13.5 16.5 13.5H21C22.6569 13.5 24 14.8431 24 16.5V21C24 22.6569 22.6569 24 21 24H16.5C14.8431 24 13.5 22.6569 13.5 21V16.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 3C0 1.34315 1.34315 0 3 0H7.5C9.15685 0 10.5 1.34315 10.5 3V7.5C10.5 9.15685 9.15685 10.5 7.5 10.5H3C1.34315 10.5 0 9.15685 0 7.5V3ZM8.03033 4.28033C8.32322 3.98744 8.32322 3.51256 8.03033 3.21967C7.73744 2.92678 7.26256 2.92678 6.96967 3.21967L4.5 5.68934L3.53033 4.71967C3.23744 4.42678 2.76256 4.42678 2.46967 4.71967C2.17678 5.01256 2.17678 5.48744 2.46967 5.78033L3.96967 7.28033C4.26256 7.57322 4.73744 7.57322 5.03033 7.28033L8.03033 4.28033Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}